module.exports = __webpack_public_path__ + "img/coupon-pc.81832fc7.png";